import BaseModelAPI from '../BaseModelAPI';

export default class PutawayHeader extends BaseModelAPI {
	static entity = '';
	static entityName = 'putawayheader';

	constructor(){

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.putawayHeaderNo = '';
		this.scannedById = '';
		this.scannedBy = {};
		this.putawayCategoryId = '';
		this.putawayCategory = {};
		this.documentStatusId = '';
		this.documentStatus = {};
		this.processDate = '';
		this.areaId = '';
		this.area = {};
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.isScanned = '';
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}
	static scanControlCard(this_, id, qrCode, putawayTypeId) {
		return this_.$http.get(`${this.entityName}/scancontrolcard?id=${id}&qrcode=${qrCode}&putawaytipe=${putawayTypeId}`)
			.then(function (response) {
				if (response != null) {
					return response.data;
				}
				this_.toast({ message: 'Gagal memproses Control Card!', title: 'Error', variant: 'danger' });
				throw error;
			})
			.catch(function (error) {
				var stringError = 'Gagal memproses Control Card!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
			});
	}
	static async scanApproval(this_, id, qrCode) {
		return await this_.$http.get(`${this.entityName}/scanapproval?id${id}&qrcode=${qrCode}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				this_.toast({ message: 'Gagal melakukan scan approval!', title: 'Error', variant: 'danger' });
				throw error;
			})
			.catch(function (error) {
				var stringError = 'Gagal melakukan scan approval!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw stringError;
			});
	}

	static async scanRack(this_, id, qrCode) {
		return this_.$http.get(`${this.entityName}/scanrack/${id}?qrcode=${qrCode}`)
			.then(async function (response) {
				if (response != null) {
					return response.data;
				}
				this_.toast({ message: 'Gagal memproses Scan Rack!', title: 'Error', variant: 'danger' });
				throw error;
			})
			.catch(function (error) {
				var stringError = 'Gagal memproses Scan Rack!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw stringError;
			});
	}

	static async finishScan(this_, data, id) {
		return this_.$http.put(`${this.entityName}/finishscan/${id}`, data)
			.then(function (response) {
				if (response != null) {
					let result = response.data;
					return result;
				}
				this_.toast({ message: 'Gagal melakukan Finish', title: 'Error', variant: 'danger' });
				throw error;
			})
			.catch(function (error) {
				var stringError = 'Gagal melakukan Finish!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					stringError = "";
					errorList.forEach(err => {
						if (stringError != "") {
							stringError += " \r\n "
						}
						stringError += err;
					})
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
			});
	}
}